import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function usePropertyById(propertyId, options, key = "getPropertyById") {
  const axiosPrivate = useAxiosPrivate();

  const getPropertyById = async (propertyId) => {
    const events = await axiosPrivate({
      method: "GET",
      url: `Property/${propertyId}`,
    }).then((res) => res.data);
    return events;
  };

  return useQuery([key, propertyId], () => getPropertyById(propertyId), {
    ...options,
  });
}

export default usePropertyById;
